module.exports = __webpack_public_path__ + "media/images/emblems/Embrach-blazon-74c2e52726f145c1f46e7292eefdc99b.svg";